import { withPaymentsClient } from 'payments-checkout-lib/data/clients';
import { getUtk } from '../utils/analytics';
import { getQueryParams, getIframeLayout } from '../utils/queryParams';
import { catchAndRethrowNetworkError, catchAndRethrowSensitiveNetworkError
// @ts-ignore Untyped module
} from 'crm_data/bCommerce/monitoring/errorUtils';
const getParentPageUrl = () => {
  const queryParams = getQueryParams();
  if (!queryParams || !getIframeLayout() || !queryParams.parentPageUrl) {
    return null;
  }
  return queryParams.parentPageUrl;
};
export const createCheckoutSession = withPaymentsClient(client => {
  const publicId = window.location.pathname.split('/payments/')[1].replace('iframe/', '');
  const queryParams = getQueryParams();
  return client.post(`sales-checkout/v2/session-templates/public/${publicId}/payments-sessions`, {
    data: Object.assign({
      customerEmail: queryParams.email || null
    }, queryParams.submissionConversionId && {
      submissionConversionId: queryParams.submissionConversionId
    })
  }).catch(e => {
    // Skip sending error message for 404s - expected for deleted payment links
    if (!e.data.includes('Error 404 Not Found')) {
      catchAndRethrowNetworkError(e);
    }
    throw e;
  });
});
export const fetchCheckoutSession = withPaymentsClient(client => {
  const paymentSessionId = window.location.pathname.split('/purchase/')[1];
  return client.get(`payments-checkout/v1/checkout-sessions/${paymentSessionId}/public`).catch(e => {
    // We don't want to send a Sentry error when a session is expired because this is a known response from BE
    // and FE shows an expected error state so the log is unnecessary.
    if (!e.data.includes('This payment session has expired.')) {
      catchAndRethrowSensitiveNetworkError(e);
    }
    throw e;
  });
});
export const fetchPaymentResult = withPaymentsClient((client, {
  id,
  clientSecret
}) => client.post(`payments-checkout/v1/checkout-sessions/${id}/payment-result`, {
  data: {
    clientSecret
  }
}));
export const createPaymentIntent = withPaymentsClient((client, {
  data
}) => {
  const paymentSessionId = window.location.pathname.split('/purchase/')[1];

  // Send hubspotUtk so formSubmission event is associated with the right user
  // Send parentPageUrl so formSubmission event is associated with the parent CMS page
  const formMetadata = {
    hubspotUtk: getUtk(),
    parentPageUrl: getParentPageUrl()
  };
  return client.post(`payments-checkout/v1/checkout-sessions/${paymentSessionId}/intent`, {
    data: Object.assign({}, data, {
      formMetadata
    })
  }).catch(catchAndRethrowSensitiveNetworkError);
});